export const REG = {
  kana: /^[\u3041-\u309fー～！？、。]*$/,
  postalCode: /^\d{7}$/,
  email: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
  tel: /^0\d{9,13}$/,
  password: /^(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
} as const
